"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.transformEntries = void 0;
const occupancyDescription_1 = require("../occupancyDescription");
const transformEntries = (entries) => {
    const uniqueFields = ["room", "occupancy", "board"];
    const fieldValues = uniqueFields.reduce((acc, field) => {
        acc[field] = new Set(entries.map((entry) => entry[field]));
        return acc;
    }, {});
    return entries.map((entry) => {
        const differences = uniqueFields.filter((field) => fieldValues[field].size > 1 || field === "room");
        const title = differences
            .map((diff) => {
            if (diff === "occupancy") {
                return (0, occupancyDescription_1.occupancyDescription)(entry[diff]);
            }
            return entry[diff];
        })
            .join(", ");
        return {
            title: title,
            guests: entry.guests,
            total: entry.total,
        };
    });
};
exports.transformEntries = transformEntries;
